import { render, staticRenderFns } from "./BundleProductTile.vue?vue&type=template&id=28662153&scoped=true&"
import script from "./BundleProductTile.vue?vue&type=script&lang=js&"
export * from "./BundleProductTile.vue?vue&type=script&lang=js&"
import style0 from "./BundleProductTile.vue?vue&type=style&index=0&id=28662153&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28662153",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppCheckbox: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppCheckbox.vue').default,ProductTileImageCarousel: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/product-tile/ProductTileImageCarousel.vue').default,ProductTileImagesLegacy: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/product-tile/ProductTileImagesLegacy.vue').default,ProductTileTitle: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/product-tile/ProductTileTitle.vue').default,ProductTileRating: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/product-tile/ProductTileRating.vue').default,AppProductTilePrice: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppProductTilePrice.vue').default,AppButton: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppButton.vue').default})
